/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/clearing_house_medium'
export default icon
